module.exports = __webpack_public_path__ + "static/media/undraw_metrics_gtu7.6231c5fb.svg";